<template>
  <div v-if="defaultVisible || visible" ref="$container">
    <no-ssr>
      <div class="recommend__all">
        <section v-if="$route.name === 'plpSearch' || hotwordable" style="margin: 0 auto">
          <div class="hot-word-search">
            <hotSearch></hotSearch>
          </div>
        </section>
        <div>
          <div
            v-if="productList && productList.length && !isMobile"
            ref="reference"
            class="product-recommend"
          >
            <GtSwiperJ
              :title="'猜你喜欢'"
              :data-list="productList"
              :slides-per-view="$store.getters.isMobile ? 3 : 4"
              :event="event"
            ></GtSwiperJ>
          </div>
          <!-- <div v-else>
          <GtSwiperJ
            :title="'猜你喜欢'"
            :data-list="productList"
            :slides-per-view="$store.getters.isMobile ? 3 : 4"
          ></GtSwiperJ>
        </div> -->
          <div v-if="isMobile && productList && productList.length">
            <div class="guess-container">
              <div class="hot-word-search__header">
                <p>猜你喜欢</p>
              </div>
              <Guess :data-list="productList.slice(0, 12)" :event="event"></Guess>
            </div>
          </div>
        </div>
      </div>
    </no-ssr>
  </div>
</template>

<script>
import { useBasic, useHome } from '@speedshop/sdk-api';
import { mapGetters } from 'vuex';
import { queryHotwords } from '@/graphql/login.gql';
import GtSwiperJ from '@/components/Common/GtSwiperJ.vue';
import { speedGetCatalogProductGuessUA } from '@/graphql/plp.gql';
import { speedGetCatalogProductBrowseUA, speedGetCatalogProductSimilarUA } from '@/graphql/pdp.gql';
import Guess from '@/components/Common/GuessMobileSwiper.vue';
import hotSearch from '@/components/Common/hotSearch.vue';
import { resetPLPCardData } from '@/utils/product.js';
// import lazyLoadMixins from '@/mixins/lazyLoad.js';
const SCHEMAS = [
  speedGetCatalogProductGuessUA,
  speedGetCatalogProductSimilarUA,
  speedGetCatalogProductBrowseUA
];

export default {
  name: 'PRecommend',
  components: {
    GtSwiperJ,
    Guess,
    hotSearch
  },
  // mixins: [lazyLoadMixins],
  props: {
    // type: 0-Search Result is Empty,1-Cart is Empty,2-Cart is Non-Empty,3-Purchased
    type: {
      type: Number,
      default: 0
    },
    defaultVisible: {
      type: Boolean,
      default: true
    },
    // 0 猜你喜欢 1 相似推荐 2 历史记录
    contentType: {
      type: String,
      default: '0'
    },
    // 查询的请求参数
    queryParams: {
      type: Object,
      default: undefined
    },
    // 是否显示hotword
    hotwordable: {
      type: Boolean,
      default: false
    },
    event: {
      type: String
    },
    moduleName: {
      type: String,
      default: '猜你喜欢'
    },
    buttonName: {
      type: String,
      default: '商品'
    },
    lazyLoad: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      productList: [],
      useHome: null,
      hotWords: [],
      visible: false,
      fetched: false
    };
  },
  computed: {
    ...mapGetters(['isMobile', 'isGuest', 'isLogin'])
  },
  beforeDestroy() {
    // window.removeEventListener('scroll', this.lazyLoadInit);
  },
  mounted() {
    if (this.lazyLoad) {
      // document.addEventListener('scroll', this.lazyLoadInit);
    } else {
      this.init();
    }
    this.hotwordable && this.handleHotWord();
  },
  methods: {
    show() {
      this.visible = true;
    },
    // lazyLoadInit() {
    //   if (this.fetched) return;
    //   const $container = this.$refs.$container;

    //   if ($container) {
    //     const isInViewport = this.isInViewport($container, 400);
    //     if (!isInViewport) return;
    //     window.removeEventListener('scroll', this.lazyLoadInit);
    //     this.fetched = true;
    //     this.init();
    //   } else {
    //     window.removeEventListener('scroll', this.lazyLoadInit);
    //     this.fetched = true;
    //     this.init();
    //   }
    // },

    async init() {
      const Basic = useBasic();
      const {
        data: { data }
      } = await Basic.gqlClient.query(SCHEMAS[this.contentType], this.queryParams);

      this.productList = data.map(item => {
        const result = resetPLPCardData(item);
        const { productList = [] } = result;
        const activityData = productList[0];
        const { mediaLink, mobileMediaLink } = activityData;
        const newProductList = productList.map(i => {
          return {
            ...i,
            operationData: {
              ...i.trackData,
              module_name: this.moduleName,
              button_name: this.buttonName
            }
          };
        });
        return {
          ...result,
          mediaLinkList: (mediaLink || mobileMediaLink || '').replace(/,http/g, '[http').split('['),
          mediaLink,
          mobileMediaLink,
          productList: newProductList,
          operationData: {
            ...result.trackData,
            module_name: this.moduleName,
            button_name: this.buttonName
          }
        };
      });
      this.$emit('getShowPre', { type: this.contentType, showPre: this.productList.length !== 0 });
      // this.$nextTick(() => {
      //   this.lazyLoadImg();
      // });
    },

    async handleHotWord() {
      this.useHome = useHome();
      const {
        data: {
          data: { hotwordsOutputs }
        }
      } = await this.useHome.gqlClient.query(queryHotwords);
      this.hotWords = hotwordsOutputs;
    }
  }
};
</script>
<style lang="scss">
.product-recommend {
  padding-top: 60px;
  .sp-lp-card__salePoint {
    display: none !important;
  }
  .swiper-j_title {
    text-align: left;
    color: var(--main-color-ua-dark-grey);
    font-size: 28px;
    font-style: normal;
    font-weight: 600;
    line-height: 40px;
    margin-bottom: 32px;
  }
  .swiper-button-prev {
    left: -25px;
  }
  .swiper-button-next {
    right: -25px;
  }
}
.guess-container {
  .hot-word-search__header {
    margin-bottom: 14px;
  }
}
.recommend__all {
  margin: 0 4% 0;
}
@media (max-width: 1024px) {
  .recommend__all {
    // padding: 0 24px;
    margin: 0;
  }
  .product-recommend {
    padding-bottom: 48px;
    margin: 0;
    padding-top: 32px;
    .swiper-j {
      border: none;
    }
    .swiper-j_title {
      font-size: 16px;
      margin-bottom: 16px;
    }
    .sp-swiper-container {
      margin: 0 auto;
      width: 100%;
      overflow: hidden;
    }
    .swiper-wrapper {
      .swiper-slide {
        width: 100% !important;
      }
    }
    .swiper-button-next {
      right: 5px !important;
      top: calc(50% - 24px) !important;
    }
    .swiper-button-prev {
      left: 5px !important;
      top: calc(50% - 24px) !important;
    }
  }
}
</style>
